<template>
  <ll-new-modal
    :open="props.open"
    title="编辑"
    width="700px"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template v-if="props.type === 'code'">
      <ll-codemirror-editor-vue3
        v-model:value="innerValue"
        language="json"
        :disabled="disabled"
        :height="'500px'"
        :options="{ minimap: { enabled: false } }"
      />
    </template>
    <template v-if="props.type === 'textarea'">
      <ll-textarea
        v-model:value="innerValue"
        :disabled="disabled"
        :autosize="{ minRows: 15 }"
      />
    </template>
    <template v-if="props.type === 'batch'">
      <batch-editing v-model:value="innerValue" />
    </template>
  </ll-new-modal>
</template>

<script setup lang="ts">
import { ref, watch, inject } from 'vue'

import { apiModalProps, apiModalEmits } from '../config'

import batchEditing from './batch-editing.vue'

defineOptions({ name: 'LlApiModal' })

const props = defineProps(apiModalProps)

const emits = defineEmits(apiModalEmits)

const innerValue = ref(props.value)

const disabled = inject('disabled')

const handleCancel = () => {
  emits('update:open', false)
}

const handleOk = () => {
  emits('update:open', false)
  emits('ok', innerValue.value)
}

watch(innerValue, (n) => {
  emits('update:value', n)
})
</script>
